import { useEffect, useState } from "react";
import { format } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { api, SLOT_GROUPS, timeLabel } from "@/lib/api";

export const ScheduleStep = ({ date, setDate, time, setTime }) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (!date) return;
    let alive = true;
    setLoading(true);
    api.get("/slots", { params: { date: format(date, "yyyy-MM-dd") } })
      .then((r) => { if (alive) setSlots(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (alive) setSlots([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [date]);

  const byTime = Object.fromEntries(slots.map((s) => [s.time, s]));

  return (
    <div className="grid gap-8 lg:grid-cols-2">
      <div className="w-fit border border-white/10 bg-[#111317] p-2" data-testid="booking-calendar">
        <Calendar mode="single" selected={date} onSelect={(d) => { setDate(d); setTime(""); }}
          disabled={[{ before: today }, { dayOfWeek: [0] }]} />
      </div>
      <div>
        <p className="eyebrow mb-4">{date ? format(date, "EEEE, MMM d") : "Pick a date first"}</p>
        {!date && <p className="text-zinc-400">Closed Sundays. Even rebels rest.</p>}
        {date && (
          <div className="flex flex-col gap-5" data-testid="booking-slots">
            {loading && <p className="text-zinc-400">Checking the schedule…</p>}
            {!loading && slots.length === 0 && <p className="text-zinc-400">No slots available. Try another date.</p>}
            {!loading && SLOT_GROUPS.map((g) => {
              const groupSlots = g.hours.map((h) => byTime[`${String(h).padStart(2, "0")}:00`]).filter(Boolean);
              if (!groupSlots.length) return null;
              return (
                <div key={g.name}>
                  <p className="eyebrow mb-3">{g.name}</p>
                  <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                    {groupSlots.map((s) => (
                      <button key={s.time} disabled={!s.available} onClick={() => setTime(s.time)} data-testid={`booking-slot-${s.time}`}
                        className={`rounded-full border px-3 py-3 font-mono-x text-sm transition-all duration-300 disabled:cursor-not-allowed disabled:border-white/5 disabled:text-zinc-600 disabled:line-through ${time === s.time ? "border-[var(--acid)] bg-acid text-black" : "border-white/15 text-zinc-200 hover:border-white/40"}`}>
                        {timeLabel(s.time).replace(":00", "")}
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
